const ActionPlanTypes = {
  SET_PLAN_DATA: 'SET_PLAN_DATA',
};

export default ActionPlanTypes;
